<div class="page-container">
  <div class="card card-form">
    <div class="row g-0">
      <div class="col-lg-6 card-body text-center">
        <div class="px-3 text-start">
          <h3 class="headings-color">Get started here</h3>
          <p class="mb-0">
            Building an integration? Get started with
            <a routerLink="/account-settings/api-access">AtomicTax's API</a>
            or browse our
            <a [href]="developersDocsUrl" target="_blank" rel="noopener noreferrer">developer documentation</a>.
          </p>
        </div>
        <img alt="setup image" class="setup-img p-lg-3 w-75" src="../../../../assets/images/dashboard/setup-img.svg">
      </div>
      <div class="col-lg-6 card-body d-flex align-items-center">
        <div class="w-100">
          <input (change)="fileChangeListener($event)" class="d-none" id="fileImportInput" type="file" />
          <div class="mb-4">
            <h3 class="mb-2">Import your transaction data into AtomicTax</h3>
            @if (usesUsageBasedStripeBilling) {
              <p class="mb-0">
                AtomicTax can import up to 60 days of data to get you started. Once imported, you'll have access to
                reports and filing.
              </p>
            } @else {
              <p class="mb-0">
                AtomicTax can import up to 60 days of data during your trial. Once imported, you'll have full access to
                reports and filing.
              </p>
            }
          </div>
          <div class="d-flex flex-wrap gap-2">
            <a class="btn btn-primary" routerLink="/account-settings/linked-accounts">Connect Integration</a>
            <a class="btn btn-outline-secondary" routerLink="/upload/sales-transactions">
              Import CSV
              <span class="mdi mdi-plus"></span>
            </a>
            <label class="btn btn-outline-secondary mb-0" for="fileImportInput">Upload file</label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6">
      <div class="card h-100">
        <div class="card-header card-header-large bg-white">
          <h4 class="m-0">Included in your plan</h4>
        </div>
        <div class="card-body">
          <div class="alert alert-success d-flex align-items-center" role="alert">
            <span class="mdi mdi-check-circle bi flex-shrink-0 me-2"></span>
            <div class="text-body">
              <strong>Accurate real-time sales tax calculations</strong>
              <br>Ensure you're collecting the correct amount, every time
            </div>
          </div>
          <div class="alert alert-success d-flex align-items-center" role="alert">
            <span class="mdi mdi-check-circle bi flex-shrink-0 me-2"></span>
            <div class="text-body">
              <strong>State &amp; country tax reports</strong>
              <br>View jurisdiction reports and track economic nexus
            </div>
          </div>
          <div class="alert alert-success d-flex align-items-center" role="alert">
            <span class="mdi mdi-check-circle bi flex-shrink-0 me-2"></span>
            <div class="text-body">
              <strong>Automated filings</strong>
              <br>Reduce the manual work and let us file for you
            </div>
          </div>
        </div>
        <div class="card-footer text-center border-0">
          <p class="mb-0">Want to learn more? <a href="https://calendly.com/atomickit/sales-tax" target="_blank">Schedule a demo</a>.</p>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card h-100">
        <div class="card-header card-header-large bg-white">
          @if (usesUsageBasedStripeBilling) {
            <h4 class="card-header__title m-0">Get started</h4>
          } @else {
            <h4 class="card-header__title m-0">Get the most out of your trial</h4>
          }
          <p class="mb-0 mt-2">Here are some resources to help you get started.</p>
        </div>
        <div class="card-body">
          <div class="list-group">
            <a routerLink="/account-settings/nexus" class="list-group-item list-group-item-action text-primary">Add tax jurisdictions</a>
            <a href="https://help.atomictax.com/" target="_blank" class="list-group-item list-group-item-action text-primary">Visit our help center</a>
            @if (!usesUsageBasedStripeBilling) {
              <a routerLink="/account-settings/plan/current" class="list-group-item list-group-item-action text-primary">Upgrade your account</a>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
